import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Particles from "@tsparticles/react";
import ReactPaginate from 'react-paginate';
import { FlashcardArray } from "react-quizlet-flashcard";

export const mainContainer = styled.div`
    width: 100vw;
    height: 100vh;
    margin: 0;
    padding: 0;
    background-color: var(--palette-one-blue);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .dontShowOnMobile {
        @media (max-width: 900px) {
            display: none;
        }
    }
`;
export const actions = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    z-index: 999;
    overflow-x: hidden;

    @media (max-width: 500px) {
        .altWithRow {
            flex-direction: row;
            justify-content: center;
            gap: 20px;
            width: 90%;
        }
    }
`;

export const goBackIcon = styled(FontAwesomeIcon)`
    font-size: 20px;
`;

export const goBackText = styled.h2`
    font-size: 1.25rem;
    text-transform: uppercase;
`;
export const textUnderline = styled.span`
    width: 100%;
    transform: scale(0);
    height: 2px;
    background-color: var(--palette-one-white);
    transition-duration: 0.2s;
`;

export const goBack = styled.div`
    position: absolute;
    width: max-content;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    top: 10px;
    left: 10px;
    color: var(--palette-one-white);
    transition-duration: 0.2s;

    &:hover {
        ${textUnderline} {
            transform: scale(1);
        }
    }
`;

export const sessionTime = styled.div`
    position: absolute;
    width: max-content;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    top: 10px;
    right: 10px;
    left: auto;
    color: var(--palette-one-white);
    transition-duration: 0.2s;
`;

export const sessionTimeText = styled.h2`
    font-size: 1.25rem;
    text-transform: uppercase;
`;

export const actionsHeader = styled.h1`
    font-size: 2.5rem;
    width: 90%;
    margin-top: 25px;
    text-align: center;
    color: var(--palette-one-white);
    animation: popUpAnimation 0.5s forwards;

    @media (max-width: 900px) {
        font-size: 2rem;
        margin-top: 0px;
    }

    @media (max-width: 500px) {
        font-size: 1.25rem;
    }
`;

export const actionsOptions = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
    flex-wrap: wrap;
    margin-top: 5%;
    height: max-content;
    width: 90%;
    gap: 35px;
    padding-bottom: 35px;

    @media (max-width: 900px) {
        margin-top: 10%;
        gap: 15px;
    }
`;

export const actionIcon = styled(FontAwesomeIcon)`
    font-size: 80px;
    color: var(--palette-one-blue);

    @media (max-width: 900px) {
        font-size: 60px;
    }
`;

export const actionText = styled.h2`
    font-size: 1.5rem;
    text-align: center;
    color: var(--palette-one-blue);

    @media (max-width: 900px) {
        font-size: 1rem;
    }
`;

export const actionOption = styled.div<{ index?: number }>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 50px;
    border-radius: 10px;
    background-color: var(--palette-one-white);
    cursor: pointer;
    gap: 25px;
    flex: 1;
    min-width: 200px;
    transition-duration: 0.2s;
    transform: scale(0);
    animation: popUpAnimation 0.5s ease-in-out ${(props) => props.index ? props.index * 0.05 : 0}s forwards;

    &:hover {
        background-color: var(--palette-one-blue);
        box-shadow: 0px 0px 10px 0px rgba(255,255,255,1), 0px 0px 10px 0px rgba(255,255,255,1);
        transform: scale(1.03);

        ${actionIcon} {
            color: var(--palette-one-white);
        }

        ${actionText} {
            color: var(--palette-one-white);
        }

        @media (max-width: 900px) {
            transform: scale(1.015);
        }
    }

    @media (max-width: 900px) {
        padding: 25px;
        min-width: 100px;
    }
`;

export const particles = styled(Particles)`
    z-index: 0;
`;

export const inputForAI = styled.div<{ index: number, placeholder: string }>`
    width: calc(70% - 24px);
    max-height: 250px;
    min-height: 50px;
    margin-top: 25px;
    border: none;
    border-radius: 5px;
    font-size: 18px;
    font-family: 'Georgia', sans-serif;
    background-color: var(--palette-one-blue);
    color: var(--palette-one-white);
    border: 2px solid var(--palette-one-white);
    outline: none;
    padding: 10px;
    box-shadow: 0px 0px 10px 0px rgba(255,255,255,0.4);
    overflow-y: auto;
    transform: scale(0);
    animation: popUpAnimation 0.5s ease-in-out ${(props) => props.index ? props.index * 0.05 : 0}s forwards;

    &:empty:before {
        content: "${(props) => props.placeholder}";
        pointer-events: none;
        color: rgba(255,255,255,0.5);
    }

    @media (max-width: 900px) {
        font-size: 16px;
        width: calc(80% - 24px);
    }

    @media (max-width: 500px) {
        font-size: 14px;
        width: calc(90% - 24px);

    }
`;
export const outputForAI = styled.div<{ index: number }>`
    width: calc(70% - 24px);
    max-height: 500px;
    min-height: 50px;
    margin-top: 25px;
    border: none;
    border-radius: 5px 5px 0 0;
    font-size: 18px;
    font-family: 'Georgia', sans-serif;
    background-color: var(--palette-one-blue);
    color: var(--palette-one-white);
    border: 2px solid var(--palette-one-white);
    outline: none;
    padding: 10px;
    box-shadow: 0px 0px 10px 0px rgba(255,255,255,0.4);
    overflow-y: auto;
    transform: scale(0);
    animation: popUpAnimation 0.5s ease-in-out ${(props) => props.index ? props.index * 0.05 : 0}s forwards;
    align-content: center;
    user-select: text;
    ms-user-select: text;
    webkit-user-select: text;
    white-space: pre-line;

    .span_title {
        font-weight: bold;
        color: var(--palette-one-white);
    }

    .span_action {
        color: var(--palette-one-white);
        cursor: pointer;
        text-transform: capitalize;
        padding: 2px 0;
        text-decoration: underline;
    }
    
    .span_action:hover {
        font-weight: bold;
        padding-left: 5px;
    }

    @media (max-width: 900px) {
        font-size: 16px;
        width: calc(80% - 24px);
        max-height: 550px;
    }

    @media (max-width: 500px) {
        font-size: 14px;
        max-height: 420px;
        width: calc(90% - 24px);
    }
`;
export const showSectionIcon = styled(FontAwesomeIcon)`
    font-size: 15px;
    color: var(--palette-one-white);
    cursor: pointer;
    transition-duration: 0.2s;
    margin: 0 0 0px 10px;

    &:hover {
        transform: scale(1.1);
    }
`;
export const youtubeVideosList = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
    flex-wrap: wrap;
    gap: 25px;
    margin: 15px 0;
`;
export const refreshYoutubeVideosIcon = styled(FontAwesomeIcon)`
    font-size: 20px;
    color: var(--palette-one-white);
    cursor: pointer;
    transition-duration: 0.2s;
    margin: 0 0 -1px 10px;

    &:hover {
        transform: scale(1.1);
    }
`;
export const youtubeVideo = styled.div<{ index: number }>`
    min-width: 220px;
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    border-radius: 10px;
    background-color: var(--palette-one-white);
    cursor: pointer;
    transition-duration: 0.2s;
    box-shadow: 0px 0px 10px 0px rgba(255,255,255,0.4);
    color: var(--palette-one-blue);
    transform: scale(0);
    animation: popUpAnimation 0.5s ease-in-out ${(props) => props.index ? props.index * 0.05 : 0}s forwards;

    &:hover {
        background-color: var(--palette-one-blue);
        box-shadow: 0px 0px 10px 0px rgba(255,255,255,1), 0px 0px 10px 0px rgba(255,255,255,1);
        color: var(--palette-one-white);
    }

    @media (max-width: 900px) {
        min-width: 150px;
    }
`;
export const youtubeVideoImage = styled.img`
    width: 100%;
    height: auto;
    border-radius: 10px;
`;
export const youtubeVideoTitle = styled.h2`
    font-size: 1.1rem;
    flex: 1;
    padding: 0 10px 10px 10px;
    text-align: center;

    @media (max-width: 900px) {
        font-size: 1rem;
    }

    @media (max-width: 500px) {
        font-size: 0.8rem;
    }
`;
export const youtubeModal = styled.div`
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.8);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
`;
export const youtubeModalContent = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 900px) {
        height: 50%;
    }

    @media (max-width: 500px) {
        height: 40%;
    }
`;
export const youtubeModalClose = styled(FontAwesomeIcon)`
    position: absolute;
    top: 25px;
    right: 25px;
    left: auto;
    font-size: 40px;
    color: var(--palette-one-white);
    cursor: pointer;
`;
export const youtubeModalVideo = styled.iframe`
    width: 80%;
    height: 80%;
    border-radius: 10px;
    box-shadow: 0px 0px 10px 0px rgba(255,255,255,0.4);
`;
export const askAboutTopicWrapper = styled.form`
    width: calc(70% - 14px);
    padding: 0 0 0 10px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border: 2px solid var(--palette-one-white);
    border-top: none;
    border-radius: 0 0 5px 5px;
    box-shadow: 0px 0px 10px 0px rgba(255,255,255,0.4);

    @media (max-width: 900px) {
        width: calc(80% - 14px);
    }

    @media (max-width: 500px) {
        width: calc(90% - 14px);
    }
`;

export const askAboutTopicInput = styled.input`
    width: 100%;
    height: 30px;
    border: none;
    border-radius: 5px;
    padding: 10px 0;
    font-size: 18px;
    font-family: 'Georgia', sans-serif;
    background-color: var(--palette-one-blue);
    color: var(--palette-one-white);
    outline: none;

    &::placeholder {
        color: rgba(255,255,255,0.5);
    }

    @media (max-width: 900px) {
        font-size: 16px;
    }

    @media (max-width: 500px) {
        font-size: 14px;
        height: 25px;
    }
`;

export const askAboutTopicButton = styled.button`
    width: auto;
    height: 100%;
    border: none;
    font-size: 18px;
    font-family: 'Georgia', sans-serif;
    background-color: var(--palette-one-blue);
    color: var(--palette-one-white);
    cursor: pointer;
    border-left: 2px solid var(--palette-one-white);
    font-weight: bold;
    font-size: 1.25rem;
    transition-duration: 0.2s;
    padding: 0 10px 0 10px;
`;

export const askAboutTopicIcon = styled(FontAwesomeIcon)`
    font-size: 30px;
    color: var(--palette-one-white);

    @media (max-width: 900px) {
        font-size: 25px;
    }

    @media (max-width: 500px) {
        font-size: 20px;
    }
`;

/* buttonOptionsMobile */

export const buttonOptionsMobile = styled.div`
    display: none;
    flex-direction: row;
    justify-content: center;
    align-items: stretch;
    flex-wrap: wrap;
    margin-top: 5%;
    height: max-content;
    width: 80%;
    gap: 35px;
    padding-bottom: 35px;

    @media (max-width: 900px) {
        display: flex;
    }

    @media (max-width: 500px) {
        width: 90%;
        gap: 15px;
    }
`;

export const buttonMobileIcon = styled(FontAwesomeIcon)`
    font-size: 80px;
    color: var(--palette-one-white);

    @media (max-width: 900px) {
        font-size: 50px;
    }

    @media (max-width: 500px) {
        font-size: 30px;
    }
`;

export const buttonMobileText = styled.h2`
    font-size: 1.5rem;
    text-align: center;
    color: var(--palette-one-white);

    @media (max-width: 900px) {
        font-size: 1rem;
    }

    @media (max-width: 500px) {
        font-size: 0.8rem;
    }
`;

export const buttonMobileOption = styled.div<{ index?: number }>`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 50px;
    border-radius: 10px;
    background-color: var(--palette-one-blue);
    border: 1px solid var(--palette-one-white);
    cursor: pointer;
    gap: 25px;
    flex: 1;
    min-width: 200px;
    transition-duration: 0.2s;
    transform: scale(0);
    animation: popUpAnimation 0.5s ease-in-out ${(props) => props.index ? props.index * 0.05 : 0}s forwards;

    &:hover {
        background-color: var(--palette-one-white);
        box-shadow: 0px 0px 10px 0px rgba(255,255,255,1), 0px 0px 10px 0px rgba(255,255,255,1);
        transform: scale(1.03);

        ${actionIcon} {
            color: var(--palette-one-blue);
        }

        ${actionText} {
            color: var(--palette-one-blue);
        }

        @media (max-width: 900px) {
            transform: scale(1.015);
        }
    }

    @media (max-width: 900px) {
        padding: 20px;
        min-width: 50px;
        gap: 15px;
    }

    @media (max-width: 500px) {
        padding: 12px 5px;
        min-width: 100px;
        gap: 10px;
    }
`;

export const buttonOptions = styled.div`
    width: 70%;	
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 25px;
    gap: 25px;
    animation: popUpAnimation 0.5s forwards;

    @media (max-width: 900px) {
        width: 80%;
    }

    @media (max-width: 500px) {
        flex-direction: column;
        width: 90%;
        gap: 0px;

        .altWithRowOption {
            width: max-content;
            padding: 10px 30px;
        }
    }
`;

export const optionButton = styled.button<{ index: number }>`
    width: 100%;
    height: 60px;
    margin-top: 25px;
    border: none;
    border-radius: 5px;
    font-size: 18px;
    font-family: 'Georgia', sans-serif;
    background-color: var(--palette-one-blue);
    color: var(--palette-one-white);
    cursor: pointer;
    border: 2px solid var(--palette-one-white);
    font-weight: bold;
    font-size: 1.25rem;
    transition-duration: 0.2s;
    text-transform: uppercase;
    font-family: 'Montserrat', sans-serif;
    transform: scale(0);
    animation: popUpAnimation 0.5s ease-in-out ${(props) => props.index ? props.index * 0.05 : 0}s forwards;

    &:hover {
        background-color: var(--palette-one-white);
        color: var(--palette-one-blue);
    }

    @media (max-width: 900px) {
        font-size: 16px;
    }

    @media (max-width: 500px) {
        font-size: 14px;
        height: 50px;
        margin-top: 15px;
    }
`;

export const orText = styled.h2`
    font-size: 1.5rem;
    margin-top: 25px;
    color: var(--palette-one-white);

    @media (max-width: 900px) {
        font-size: 1rem;
    }
`;
/* list Component */
export const listContainer = styled.div<{ index: number }>`
    width: 80%;
    height: 65%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 25px;
    transform: scale(0);
    animation: popUpAnimation 0.5s ease-in-out ${(props) => props.index ? props.index * 0.05 : 0}s forwards;

    @media (max-width: 900px) {
        width: 90%;
    }

    @media (max-width: 500px) {
        width: 95%;
        height: 55%;
    }
`;
export const listItems = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding: 10px 0;
    gap: 25px;
`;
export const listItem = styled.div`
    width: calc(95% - 30px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 15px;
    border-radius: 10px;
    background-color: var(--palette-one-white);
    cursor: pointer;
    transition-duration: 0.2s;
    box-shadow: 0px 0px 10px 0px rgba(255,255,255,0.4);
    color: var(--palette-one-blue);

    &:hover {
        background-color: var(--palette-one-blue);
        box-shadow: 0px 0px 10px 0px rgba(255,255,255,1), 0px 0px 10px 0px rgba(255,255,255,1);
        transform: scale(1.005);
        color: var(--palette-one-white);

        @media (max-width: 900px) {
            transform: scale(1.015);
        }
    }

    @media (max-width: 500px) {
        width: calc(95% - 20px);
        padding: 10px 10px;
    }
`;
export const listItemHeader = styled.div`
    width: 100%;
    text-align: center;
`;
export const listItemTitle = styled.h2`
    font-size: 1.5rem;

    @media (max-width: 900px) {
        font-size: 1.25rem;
    }

    @media (max-width: 500px) {
        font-size: 1rem;
    }
`;
export const listItemBody = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    gap: 35px;

    @media (max-width: 900px) {
        gap: 20px;
    }

    @media (max-width: 500px) {
        gap: 10px;
    }
`;
export const listItemBodyInfo = styled.h2`
    font-size: 1.25rem;

    @media (max-width: 900px) {
        font-size: 1rem;
    }

    @media (max-width: 500px) {
        font-size: 0.8rem;
    }
`;

export const reactPaginate = styled(ReactPaginate)`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-top: 20px;
    width: 100%;

    .page-item {
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        background-color: var(--palette-one-white);
        color: var(--palette-one-blue);
        cursor: pointer;
        transition-duration: 0.2s;
    }

    .page-item:hover {
        background-color: var(--palette-one-blue);
        color: var(--palette-one-white);
        box-shadow: 0px 0px 10px 0px rgba(255,255,255,1), 0px 0px 10px 0px rgba(255,255,255,1);
    }

    .page-item.active {
        background-color: var(--palette-one-blue);
        color: var(--palette-one-white);
        box-shadow: 0px 0px 10px 0px rgba(255,255,255,1), 0px 0px 10px 0px rgba(255,255,255,1);
    }

    .page-link {
        font-size: 1.25rem;
        font-weight: bold;
        text-decoration: none;
        width: 40px;
        height: 40px;
        text-align: center;
        align-content: center;
    }
`;
export const noItems = styled.h2`
    height: 100%;
    font-size: 2.5rem;
    color: var(--palette-one-white);
    margin-top: 25px;
    text-align: center;
    align-content: center;

    @media (max-width: 900px) {
        font-size: 2rem;
    }

    @media (max-width: 500px) {
        font-size: 1.5rem;
    }
`;
export const topicsChecklist = styled.div`
    width: calc(70% - 24px);
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-top: 25px;

    @media (max-width: 900px) {
        width: calc(80% - 24px);
    }

    @media (max-width: 500px) {
        width: calc(90% - 24px);
        align-items: stretch;
        height: max-content;
    }
`;
export const topicItem = styled.div<{ active: boolean }>`
    min-width: max-content;
    display: flex;
    flex-direction: row;
    flex: 1;
    justify-content: center;
    align-items: center;
    gap: 10px;
    padding: 15px;
    border-radius: 10px;
    background-color: var(--palette-one-white);
    cursor: pointer;
    transition-duration: 0.2s;
    box-shadow: 0px 0px 10px 0px rgba(255,255,255,0.4);
    color: var(--palette-one-blue);

    &:hover {
        background-color: var(--palette-one-blue);
        box-shadow: 0px 0px 10px 0px rgba(255,255,255,1), 0px 0px 10px 0px rgba(255,255,255,1);
        transform: scale(1.005);
        color: var(--palette-one-white);

        @media (max-width: 900px) {
            transform: scale(1.015);
        }
    }

    ${(props) => props.active ? `
        background-color: var(--palette-one-blue);
        box-shadow: 0px 0px 10px 0px rgba(255,255,255,1), 0px 0px 10px 0px rgba(255,255,255,1);
        transform: scale(1.005);
        color: var(--palette-one-white);
    ` : null}

    @media (max-width: 500px) {
        min-width: 100px;
        padding: 10px;
    }
`;
export const topicItemCheckWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
`;
export const topicItemCheck = styled(FontAwesomeIcon)`
    font-size: 20px;
`;
export const topicItemText = styled.h2`
    font-size: 1.25rem;

    @media (max-width: 900px) {
        font-size: 1rem;
    }

    @media (max-width: 500px) {
        font-size: 0.8rem;
    }
`;

/* Questions */
export const questionsTitle = styled.h1`
    font-size: 2rem;
    width: calc(70% - 24px);
    margin-top: 25px;
    text-align: center;
    color: var(--palette-one-white);
    animation: popUpAnimation 0.5s forwards;

    @media (max-width: 900px) {
        width: calc(80% - 24px);
        font-size: 1.75rem;
        margin-bottom: 15px;
    }

    @media (max-width: 500px) {
        width: calc(90% - 24px);
        font-size: 1.2rem;
    }
`;
export const questionOptions = styled.div`
    width: calc(70% - 24px);
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
    margin-top: 25px;

    @media (max-width: 900px) {
        width: calc(80% - 24px);
        display: flex;
        flex-direction: column;
        gap: 15px;
        margin-top: 15px;
    }

    @media (max-width: 500px) {
        width: calc(90% - 24px);
        gap: 10px;
    }
`;
export const questionUniqueOption = styled.div<{ active: boolean }>`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    text-align: left;
    gap: 10px;
    padding: 20px;
    border-radius: 10px;
    background-color: var(--palette-one-white);
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0px 0px 10px 0px rgba(255,255,255,0.4);
    color: var(--palette-one-blue);
    height: 50%;

    &:hover {
        background-color: var(--palette-one-blue);
        box-shadow: 0px 0px 10px 0px rgba(255,255,255,1), 0px 0px 10px 0px rgba(255,255,255,1);
        transform: scale(1.005);
        color: var(--palette-one-white);
    }

    ${(props) => props.active && `
        background-color: var(--palette-one-blue);
        box-shadow: 0px 0px 10px 0px rgba(255,255,255,1), 0px 0px 10px 0px rgba(255,255,255,1);
        transform: scale(1.005);
        color: var(--palette-one-white);
    `}

    @media (max-width: 900px) {
        padding: 20px;
        gap: 5px;
    }

    @media (max-width: 500px) {
        padding: 15px;
        gap: 5px;
    }
`;
export const questionUniqueOptionWrapper = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
`;
export const questionOptionCheck = styled(FontAwesomeIcon)`
    font-size: 20px;

    @media (max-width: 900px) {
        font-size: 20px;
    }

    @media (max-width: 500px) {
        font-size: 15px;
    }
`;
export const questionOptionText = styled.h2`
    font-size: 1.25rem;

    @media (max-width: 900px) {
        font-size: 1rem;
    }

    @media (max-width: 500px) {
        font-size: 0.9rem;
    }
`;
export const outputForQuestions = styled.div<{ index: number }>`
    width: calc(70% - 24px);
    max-height: 500px;
    min-height: 50px;
    margin-top: 25px;
    border: none;
    border-radius: 5px 5px 0 0;
    font-size: 18px;
    font-family: 'Georgia', sans-serif;
    background-color: var(--palette-one-blue);
    color: var(--palette-one-white);
    border: 2px solid var(--palette-one-white);
    outline: none;
    padding: 10px;
    box-shadow: 0px 0px 10px 0px rgba(255,255,255,0.4);
    overflow-y: auto;
    transform: scale(0);
    animation: popUpAnimation 0.5s ease-in-out ${(props) => props.index ? props.index * 0.05 : 0}s forwards;
    align-content: center;
    user-select: text;
    ms-user-select: text;
    webkit-user-select: text;
    white-space: pre-line;

    @media (max-width: 900px) {
        font-size: 16px;
    }

    .span_title {
        font-weight: bold;
        color: var(--palette-one-white);
    }

    .span_action {
        color: var(--palette-one-white);
        cursor: pointer;
        text-transform: capitalize;
        padding: 2px 0;
        text-decoration: underline;
    }
    
    .span_action:hover {
        font-weight: bold;
        padding-left: 5px;
    }

    @media (max-width: 900px) {
        font-size: 16px;
        width: calc(80% - 24px);
        max-height: 550px;
    }

    @media (max-width: 500px) {
        font-size: 14px;
        max-height: 420px;
        width: calc(90% - 24px);
    }
`;
export const flashcardsArray = styled(FlashcardArray)``;
export const flashcardsArrayWrapper = styled.div`
    width: calc(50% - 24px);
    height: max-content;
    transition-duration: 0.2s;

    .FlashcardArrayWrapper__controls {
        transform: scale(1.5);
    }

    .FlashcardArrayWrapper__controls button svg path {
        fill: var(--palette-one-white) !important;
    }

    .FlashcardWrapper__item--content {
        @media (max-width: 500px) {
            font-size: 1.25rem !important;
        }
    }

    @media(max-width: 1366px) {
        width: calc(70% - 24px);
    }

    @media(max-width: 900px) {
        width: calc(80% - 24px);
    }

    @media(max-width: 500px) {
        width: calc(95% - 24px);

        .FlashcardArrayWrapper {
            height: 100%;
        }
    }
`;
export const flashcardsTitle = styled.h1`
    font-size: 2rem;
    width: calc(70% - 24px);
    margin: 25px 0;
    text-align: center;
    color: var(--palette-one-white);
    animation: popUpAnimation 0.5s forwards;

    @media (max-width: 900px) {
        width: calc(80% - 24px);
        font-size: 1.75rem;
        margin: 25px 0;
    }

    @media (max-width: 500px) {
        width: calc(90% - 24px);
        font-size: 1.25rem;
        margin: 25px 0;
    }
`;